<template>
  <t-default-entry
    sub-heading="Sign Up"
    heading="新規お申し込み"
    :navigation-items="navigationItems"
    :class="componentClassName"
  >
    <div v-if="error" class="t-application-invite-user-sms-verify-phone-number-input__alert">
      <a-alert :title="errorMessage" color="error" size="small" />
    </div>
    <div class="t-application-invite-user-sms-verify-phone-number-input__intro">
      <a-heading heading="SMS認証" variant="center" tag="h3"></a-heading>
      <a-text>電話番号を入力し、下のボタンをタップすると、お客様のSMSに認証コードが送られます。</a-text>
    </div>
    <form class="t-application-invite-user-sms-verify-phone-number-input__form" @submit.prevent="handleFormSubmit">
      <div class="t-application-invite-user-sms-verify-phone-number-input__group">
        <m-form-input class="t-application-invite-user-sms-verify-phone-number-input__input" label="電話番号">
          <a-text-field v-model="phoneNumber" type="number" name="" placeholder="0312345678" />
          <template #note>
            <a-caption-list>
              <li>通信料はお客さまのご負担となります。</li>
            </a-caption-list>
          </template>
        </m-form-input>
      </div>
      <m-button-container class="t-application-invite-user-sms-verify-phone-number-input__buttons">
        <a-button variant="block" submit="submit" color="primary">SMSに認証コードを送る</a-button>
        <a-button color="primary" @click="handleCancelClick">戻る</a-button>
      </m-button-container>
    </form>
  </t-default-entry>
</template>

<script>
import { mapModifiers } from '@/libs/component';

import TDefaultEntry from '@/components/templates/default-entry';
import AButton from '@/components/atoms/button';
import AText from '@/components/atoms/text';
import AHeading from '@/components/atoms/heading';
import MFormInput from '@/components/molecules/form-input';
import MButtonContainer from '@/components/molecules/button-container';
import ATextField from '@/components/atoms/text-field';
import ACaptionList from '@/components/atoms/caption-list';
import ACheckbox from '@/components/atoms/checkbox';
import AAlert from '@/components/atoms/alert';

export default {
  name: 't-application-invite-user-sms-verify-phone-number-input',
  components: {
    TDefaultEntry,
    AButton,
    AHeading,
    AText,
    MFormInput,
    ATextField,
    MButtonContainer,
    ACaptionList,
    AAlert,
  },
  props: {
    error: {
      type: Boolean,
      default: false,
    },
    errorMessage: {
      type: String,
      default: '',
    },
    class: {
      type: String,
      default: '',
    },
    navigationItems: {
      type: Array,
      default: new Array(0),
    },
    handleCancelClick: {
      type: Function,
      default: () => {},
    },
    handleSubmitClick: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    return {
      phoneNumber: '',
    };
  },
  computed: {
    componentClassName() {
      const baseClassName = mapModifiers(
        't-application-invite-user-sms-verify-phone-number-input',
        this.error ? 'error' : ''
      );
      return `${baseClassName} ${this.class}`.trim();
    },
  },
  methods: {
    handleFormSubmit(e) {
      e.preventDefault();
      this.handleSubmitClick(this.phoneNumber);
    },
  },
};
</script>
